import { render } from "./ContactInfo.vue?vue&type=template&id=21b777e1"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\77460\\Desktop\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__